<template>
  <div class="panel">
    <div class="panel-heading">
      <span v-if="currentDate">Treasury bond yields as of <formatted-date :date="currentDate"/></span>
    </div>
    <table id="yield-curve-legend" class="table">
      <thead>
      <tr>
        <th>duration</th>
        <th>yield</th>
        <th>bps change</th>
        <th>% change</th>
      </tr>
      </thead>
      <tbody>
        <yield-table-row v-for="(label, index) in data.SHORT_DURATION_LABELS"
                         :label="label[1]"
                         :percentage-yield="yieldsForDate ? yieldsForDate[index][0] : NaN"
                         :bps-change="yieldsForDate ? yieldsForDate[index][1] : NaN"
                         :percentage-change="yieldsForDate ? yieldsForDate[index][2] : NaN" />
      </tbody>
    </table>
  </div>
</template>
<script>
  import * as data from '../../../client/src/data.js'
  import YieldTableRow from './YieldTableRow'
  import FormattedDate from './FormattedDate'
  export default {
    components: {YieldTableRow, FormattedDate},
    data() {
      return {
        data: data
      }
    },
    props: {
      yieldsForDate: {
        required: true
      },
      currentDate: {
        required: true
      }
    }
  }
</script>

